import Link from "next/link";
import {scrollToElement} from "@/utils/scrollToElement";

type ColocationDataType = {
  type: string;
  rackSpace: string;
  power: string;
  remoteHands: string;
  location: string;
  contractLength: string;
  price: string;
};

export const COLOCATION_DATA: ColocationDataType[] = [
  {
    type: "Colo-1",
    rackSpace: "42U",
    power: "Single Phase 208v 20A",
    remoteHands: "2 Hours/month",
    location: "Dallas, USA",
    contractLength: "24 Months",
    price: "$1100",
  },
  {
    type: "Colo-2",
    rackSpace: "42U",
    power: "Single Phase 120v 15A",
    remoteHands: "4 Hours/month",
    location: "Fremont, USA",
    contractLength: "3 Months",
    price: "$800",
  },
  {
    type: "Colo-3",
    rackSpace: "42U",
    power: "Single Phase 208v 30A",
    remoteHands: "2 Hours/month",
    location: "New Jersey, USA",
    contractLength: "24 Months",
    price: "$1750",
  },
  {
    type: "Colo-4",
    rackSpace: "42U",
    power: "Single Phase 208v 20A",
    remoteHands: "2 Hours/month",
    location: "Columbus, USA",
    contractLength: "24 Months",
    price: "$1750",
  },
  {
    type: "Colo-5",
    rackSpace: "42U",
    power: "Single Phase 208v 20A",
    remoteHands: "2 Hours/month",
    location: "Montreal, Canada",
    contractLength: "24 Months",
    price: "$1100",
  },
  {
    type: "Colo-6",
    rackSpace: "42U",
    power: "Single Phase 240v 20A",
    remoteHands: "2 Hours/month",
    location: "NCR, India",
    contractLength: "24 Months",
    price: "$4000",
  },
  {
    type: "Colo-7",
    rackSpace: "42U",
    power: "Single Phase 240v 20A",
    remoteHands: "2 Hours/month",
    location: "Bangalore, India",
    contractLength: "24 Months",
    price: "$4000",
  },
];

export const COLOCATION_FOOTER_CONSTANTS = {
  btnText: "Contact Us for Custom Colo Pricing",
  text1: (
    <>
      These are indicative prices for 42U rack space colocation options. We also manage
      custom colocation solutions as per your infrastructure needs. For accurate pricing,
      availability, and tailored solutions, please{" "}
      <Link
        href="#contact-us"
        onClick={(e) => {
          e.preventDefault();
          scrollToElement("contact-us", 120);
        }}
        style={{textDecoration: "underline", color: "#1E87F0", fontWeight: 700}}
      >
        contact our sales team
      </Link>
      .
    </>
  ),
};
